import ExampleOfIdentity from "src/assets/images/verification/sample-doc/identity.png";
import ExampleOfSelfie from "src/assets/images/verification/sample-doc/selfie.png";
import ExampleLetterOfAttorney from "src/assets/images/verification/sample-doc/letter-of-attorney.png";
import ExampleDeedOfEstablishment from "src/assets/images/verification/sample-doc/deed-of-establishment.png";
import ExampleDeedOfLatestBoard from "src/assets/images/verification/sample-doc/deed-of-latest-board.png";
import ExampleDeedOfArticlesOfAssociation from "src/assets/images/verification/sample-doc/deed-of-articles-of-association.png";
import ExampleOfNIB from "src/assets/images/verification/sample-doc/nib.png";
import ExampleOfNPWP from "src/assets/images/verification/sample-doc/npwp.webp";
import ExampleOfBusinessCatalogue from "src/assets/images/verification/sample-doc/business-catalogue.png";
import ExampleOfBusinessActivityLegal from "src/assets/images/verification/sample-doc/business-activity/offline-online-legal.webp";
import ExampleOfBusinessActivityLegal2 from "src/assets/images/verification/sample-doc/business-activity/offline-online-legal-2.webp";
import ExampleOfBusinessActivityUMKMOnline from "src/assets/images/verification/sample-doc/business-activity/online-umkm.webp";
import ExampleOfBusinessActivityUMKMOnline2 from "src/assets/images/verification/sample-doc/business-activity/online-umkm-2.webp";
import ExampleOfBusinessActivityUMKMOffline from "src/assets/images/verification/sample-doc/business-activity/offline-umkm.webp";

const COMMON_REQUIRED_DOCS_LEGAL_ENTITY = [
  { title: "power-of-attorney", subtitle: "power-of-attorney-desc" },
  { title: "identity-card", subtitle: "identity-card-desc" },
  { title: "npwp" },
  { title: "nib" },
  { title: "deed-of-establishment" },
  { title: "sk-kemenkumham" },
  { title: "articles-of-association", subtitle: "change-deed" },
  { title: "deed-of-latest-board", subtitle: "change-deed" }
];

export const REQUIREMENT_DOCS = {
  common_legal_entity: [
    ...COMMON_REQUIRED_DOCS_LEGAL_ENTITY // common required docs for llc, cv, firm, bpr, bprs
  ],
  individual_company: [
    { title: "power-of-attorney", subtitle: "power-of-attorney-desc" },
    { title: "identity-card", subtitle: "identity-card-desc" },
    { title: "npwp" },
    { title: "nib" },
    { title: "deed-of-establishment" },
    { title: "sk-kemenkumham" }
  ],
  pjp: [...COMMON_REQUIRED_DOCS_LEGAL_ENTITY, { title: "bi-license" }],
  cooperative: [...COMMON_REQUIRED_DOCS_LEGAL_ENTITY, { title: "local-gov-permit" }],
  bank: [...COMMON_REQUIRED_DOCS_LEGAL_ENTITY, { title: "ojk-license" }],
  bmt: [...COMMON_REQUIRED_DOCS_LEGAL_ENTITY, { title: "local-gov-permit" }],
  foundation: [...COMMON_REQUIRED_DOCS_LEGAL_ENTITY, { title: "foundation-register-sign" }],
  ministry_government: [
    { title: "power-of-attorney", subtitle: "power-of-attorney-desc" },
    { title: "identity-card", subtitle: "identity-card-desc" },
    { title: "npwp" },
    { title: "auth-representative-docs" }
  ],
  university: [
    { title: "power-of-attorney", subtitle: "power-of-attorney-desc" },
    { title: "identity-card", subtitle: "identity-card-desc" },
    { title: "npwp" },
    { title: "nib" },
    { title: "statute" }
  ]
};

export const ADDITIONAL_DOCS_INDIVIDUAL = [
  { key: 1, text: "content.identity-card" },
  { key: 2, text: "content.selfie-with-identity" }
];
export const ADDITIONAL_DOCS_COMMON = [
  { key: 3, text: "content.channel-online" },
  { key: 4, text: "content.business-activity" }
];
export const ADDITIONAL_DOCS_ACCEPT_PAYMENT = [...ADDITIONAL_DOCS_COMMON, { key: 5, text: "content.bank-settlement" }];
export const ADDITIONAL_DOCS_INTERNATIONAL_TRANSER = [
  ...ADDITIONAL_DOCS_COMMON,
  { key: 6, text: "content.npwp" },
  { key: 7, text: "content.nib" }
];

export const GUIDANCE_UPLOAD_KEY = {
  UNVERIFIED_OWNER: "unverified_owner",
  UNVERIFIED_OWNER_SELFIE: "unverified_owner_selfie",
  REPRESENTATIVE: "representative",
  UNVERIFIED_OWNER_SELFIE_PASSPORT: "unverified_owner_selfie_passport"
};
export const GUIDANCE_UPLOAD_ID = {
  [GUIDANCE_UPLOAD_KEY.UNVERIFIED_OWNER]: ["doc-quality", "format-id"],
  [GUIDANCE_UPLOAD_KEY.UNVERIFIED_OWNER_SELFIE]: ["selfie-quality", "selfie-with-ktp-position", "format-selfie"],
  [GUIDANCE_UPLOAD_KEY.REPRESENTATIVE]: [
    "letter-of-attorney.content.0",
    "letter-of-attorney.content.1",
    "letter-of-attorney.content.2",
    "letter-of-attorney.content.3",
    "doc-quality",
    "format-doc"
  ],
  [GUIDANCE_UPLOAD_KEY.UNVERIFIED_OWNER_SELFIE_PASSPORT]: [
    "selfie-quality",
    "selfie-with-passport-position",
    "format-selfie"
  ]
};

export const DOCUMENTS_TYPE = {
  IDENTITY_DOCUMENT: "identity_image",
  FACE_AND_IDENTITY_IMAGE_DOCUMENT: "face_and_identity_image",
  LETTER_OF_ATTORNEY_DOCUMENT: "letter_of_attorney",
  SIUP_DOCUMENT: "siup",
  INDUSTRY_LICENSE_DOCUMENT: "industry_license",
  DEED_OF_ESTABLISMENT_DOCUMENT: "deed_of_incorporation",
  SK_KEMENKUMHAM_DOCUMENT: "sk_kemenkumham",
  SK_KEMENKUMHAM_AMENDMENT_DOCUMENT: "sk_kemenkumham_amandemen",
  COMPANY_NPWP_DOCUMENT: "company_npwp",
  ARTICLES_OF_ASSOCIATION_DOCUMENT: "deed_of_amandment_articles_association",
  DEED_OF_LATEST_BOARD_DOCUMENT: "deed_of_change_management",
  NIB_DOCUMENT: "nib",
  ADDITIONAL_DOC_DOCUMENT: "additional_doc",
  BUSINESS_CATALOG_DOCUMENT: "business_catalog",
  BUSINESS_ACTIVITIES_PHOTO_DOCUMENT: "business_activities_photo",
  TNC_CONTACT_POLICY_INFO_DOCUMENT: "tnc_contact_policy_info",
  COMPANY_DETAILS: "company_details",
  INDUSTRY_LICENSE_3_DOCUMENT: "industry_license_3"
};

export const OWNER_DOCUMENTS = {
  KTP: "ktp",
  PASSPORT: "paspor",
  SELFIE: "selfie",
  FACE_AND_IDENTITY_IMAGE: "face-and-identity-image",
  LETTER_OF_ATTORNEY: "letter-of-attorney"
};

export const ENTITY_BASED_LICENSE = {
  SIUP: "siup",
  SIUP_FOUNDATION: "siup-foundation",
  TANDA_DAFTAR_YAYASAN: "tdy",
  GOV_PERMISSION: "gov-permission",
  OJK_LICENSE: "ojk-license",
  BI_LICENSE: "bi-license",
  MINISTRY_PERMISSION: "ministry-permission",
  GOVERNMENT_ENTITIES_PERMISSION: "government-entities-permission",
  GOVERNMENT_AGENCY_PERMISSION: "government-agency-permission",
  UNIVERSITY_PERMISSION: "university-permission"
};

export const INDUSTRY_BASED_LICENSE = {
  INDUSTRY_LICENSE: "industry-license",
  OJK_LICENSE: "ojk-license",
  BI_LICENSE: "bi-license",
  PSAT_PD: "psat-pd",
  BPOM_CIRCULATION_LICENSE: "bpom-circulation-license",
  IPP: "ipp",
  SERTIFIKASI_PERANGKAT_TELKOM: "sertifikasi-perangkat-telkom",
  OPERATIONAL_LICENSE_CITY_GOV: "operational-license-city-gov",
  PHARMACY_LICENSE: "pharmacy-license",
  COOPERATIVE_BUSINESS_LICENSE_OJK: "cooperative-business-license-ojk",
  OPERATIONAL_LICENSE_MINISTRY_TOURISM: "operational-license-ministry-tourism",
  BAPPEBTI_LICENSE: "bappebti-license",
  SIUPMSE: "siupmse",
  TDPSE: "tdpse",
  OPERATIONAL_LICENSE_FROM_DINKES: "operational-license-from-dinkes",
  MEDICAL_EQUIPMENT_DISTRIBUTION_LICENSE: "medical-equipment-distribution-license",
  SERTIFIKAT_PRODUKSI_ALAT_KESEHATAN: "sertifikat-produksi-alat-kesehatan",
  BUSINESS_LICENSE_FROM_KEMENHUB: "business-license-from-kemenhub"
};

export const COMPANY_DOCUMENTS = {
  DEED_OF_ESTABLISMENT: "deed-of-establishment",
  ARTICLES_OF_ASSOCIATION: "articles-of-association",
  DEED_OF_LATEST_BOARD: "deed-of-latest-board",
  NPWP_OWNER: "npwp-owner",
  NPWP: "npwp",
  NIB: "nib",
  SK_KEMENKUMHAM: "sk-kemenkumham",
  SK_KEMENKUMHAM_AMENDMENT: "sk-kemenkumham-amendment",
  ADDITIONAL_DOC: "additional-doc",
  BUSINESS_CATALOG_ONLINE: "business-catalog-online",
  BUSINESS_CATALOG_OFFLINE: "business-catalog-offline",
  TNC_CONTACT_POLICY_INFO: "tnc-contact-policy-info",
  BUSINESS_ACTIVITIES_PHOTO_INDIVIDUAL_OFFLINE: "business-activities-photo-individual-offline",
  BUSINESS_ACTIVITIES_PHOTO_INDIVIDUAL_ONLINE: "business-activities-photo-individual-online",
  BUSINESS_ACTIVITIES_PHOTO_LEGAL_ENTITY: "business-activities-photo-legal-entity",
  ...ENTITY_BASED_LICENSE,
  ...INDUSTRY_BASED_LICENSE
};

export const GUIDANCE_COMMONS = ["commons.quality", "commons.combine", "commons.format"];
export const GUIDANCE_COMMONS_2 = ["commons.quality", "commons.format"];
export const GUIDANCE_COMMONS_3 = ["commons.quality", "commons.format-image"];
export const GUIDANCE_COMMONS_4 = ["commons.quality", "commons.format-image-id"];
export const GUIDANCE_COMMONS_5 = [
  "commons.signed-by-authorized-official",
  "commons.contains-complete-information",
  "commons.valid-if-any-expiration"
];
export const GUIDANCE_COMMONS_6 = ["commons.signed-by-authorized-official", "commons.contains-complete-information-2"];
export const GUIDANCE_COMMONS_7 = ["commons.signed-by-authorized-official", "commons.valid-if-any-expiration"];

export const GENERAL_GUIDANCE_UPLOAD = {
  title: "general.title",
  content: ["general.quality", "general.combine", "general.colored"]
};

export const GUIDANCE_UPLOAD_ENTITY_BASED_LICENSE = {
  [COMPANY_DOCUMENTS.TANDA_DAFTAR_YAYASAN]: {
    title: "entity-license.tdy.title",
    text: ["entity-license.tdy.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.GOV_PERMISSION]: {
    title: "entity-license.gov-permission.title",
    text: ["entity-license.gov-permission.content.0", ...GUIDANCE_COMMONS_6]
  },
  [COMPANY_DOCUMENTS.OJK_LICENSE]: {
    title: "entity-license.ojk-license.title",
    text: ["entity-license.ojk-license.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.BI_LICENSE]: {
    title: "entity-license.bi-license.title",
    text: ["entity-license.bi-license.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.MINISTRY_PERMISSION]: {
    title: "entity-license.ministry.title",
    text: ["entity-license.ministry.content.0", ...GUIDANCE_COMMONS_7]
  },
  [COMPANY_DOCUMENTS.GOVERNMENT_ENTITIES_PERMISSION]: {
    title: "entity-license.government-entities.title",
    text: ["entity-license.goverment-entities.content.0", ...GUIDANCE_COMMONS_7]
  },
  [COMPANY_DOCUMENTS.GOVERNMENT_AGENCY_PERMISSION]: {
    title: "entity-license.government-agency.title",
    text: ["entity-license.government-agency.content.0", ...GUIDANCE_COMMONS_7]
  },
  [COMPANY_DOCUMENTS.UNIVERSITY_PERMISSION]: {
    title: "entity-license.university.title",
    text: ["entity-license.university.content.0", ...GUIDANCE_COMMONS_6]
  }
};

export const GUIDANCE_UPLOAD_INDUSTRY_BASED_LICENSE = {
  [COMPANY_DOCUMENTS.PSAT_PD]: {
    title: "industry-license.psat-pd.title",
    text: ["industry-license.psat-pd.content.0", ...GUIDANCE_COMMONS_7]
  },
  [COMPANY_DOCUMENTS.BPOM_CIRCULATION_LICENSE]: {
    title: "industry-license.bpom-circulation-license.title",
    text: ["industry-license.bpom-circulation-license.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.IPP]: {
    title: "industry-license.ipp.title",
    text: ["industry-license.ipp.content.0", ...GUIDANCE_COMMONS_7]
  },
  [COMPANY_DOCUMENTS.SERTIFIKASI_PERANGKAT_TELKOM]: {
    title: "industry-license.sertifikasi-perangkat-telkom.title",
    text: ["industry-license.sertifikasi-perangkat-telkom.content.0", ...GUIDANCE_COMMONS_7]
  },
  [COMPANY_DOCUMENTS.OPERATIONAL_LICENSE_CITY_GOV]: {
    title: "industry-license.operational-license-city-gov.title",
    text: ["industry-license.operational-license-city-gov.content.0", ...GUIDANCE_COMMONS_6]
  },
  [COMPANY_DOCUMENTS.PHARMACY_LICENSE]: {
    title: "industry-license.pharmacy-license.title",
    text: ["industry-license.pharmacy-license.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.COOPERATIVE_BUSINESS_LICENSE_OJK]: {
    title: "industry-license.cooperative-business-license-ojk.title",
    text: ["industry-license.cooperative-business-license-ojk.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.OPERATIONAL_LICENSE_MINISTRY_TOURISM]: {
    title: "industry-license.operational-license-ministry-tourism.title",
    text: ["industry-license.operational-license-ministry-tourism.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.BAPPEBTI_LICENSE]: {
    title: "industry-license.bappebti-license.title",
    text: ["industry-license.bappebti-license.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.SIUPMSE]: {
    title: "industry-license.siupmse.title",
    text: ["industry-license.siupmse.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.TDPSE]: {
    title: "industry-license.tdpse.title",
    text: ["industry-license.tdpse.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.OPERATIONAL_LICENSE_FROM_DINKES]: {
    title: "industry-license.operational-license-from-dinkes.title",
    text: ["industry-license.operational-license-from-dinkes.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.MEDICAL_EQUIPMENT_DISTRIBUTION_LICENSE]: {
    title: "industry-license.medical-equipment-distribution-license.title",
    text: ["industry-license.medical-equipment-distribution-license.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.SERTIFIKAT_PRODUKSI_ALAT_KESEHATAN]: {
    title: "industry-license.sertifikat-produksi-alat-kesehatan.title",
    text: ["industry-license.sertifikat-produksi-alat-kesehatan.content.0", ...GUIDANCE_COMMONS_5]
  },
  [COMPANY_DOCUMENTS.BUSINESS_LICENSE_FROM_KEMENHUB]: {
    title: "industry-license.business-license-from-kemenhub.title",
    text: ["industry-license.business-license-from-kemenhub.content.0", ...GUIDANCE_COMMONS_5]
  }
};

export const GUIDANCE_UPLOAD_DOCUMENTS = {
  [OWNER_DOCUMENTS.KTP]: {
    text: GUIDANCE_COMMONS_4,
    image: { 1: ExampleOfIdentity }
  },
  [OWNER_DOCUMENTS.PASSPORT]: {
    text: GUIDANCE_COMMONS_3
  },
  [OWNER_DOCUMENTS.SELFIE]: {
    text: GUIDANCE_COMMONS_4,
    image: { 1: ExampleOfSelfie }
  },
  [OWNER_DOCUMENTS.FACE_AND_IDENTITY_IMAGE]: {
    text: GUIDANCE_COMMONS_4
  },
  [OWNER_DOCUMENTS.LETTER_OF_ATTORNEY]: {
    title: "letter-of-attorney.title",
    text: [
      "letter-of-attorney.content.0",
      "letter-of-attorney.content.1",
      "letter-of-attorney.content.2",
      "letter-of-attorney.content.3",
      ...GUIDANCE_COMMONS_2
    ],
    image: { 1: ExampleLetterOfAttorney }
  },
  [COMPANY_DOCUMENTS.DEED_OF_ESTABLISMENT]: {
    title: "deed-of-establishment.title",
    text: [
      "deed-of-establishment.content.0",
      "deed-of-establishment.content.1",
      "deed-of-establishment.content.2",
      "deed-of-establishment.content.3"
    ],
    image: { 1: ExampleDeedOfEstablishment }
  },
  [COMPANY_DOCUMENTS.ARTICLES_OF_ASSOCIATION]: {
    title: "articles-of-association.title",
    text: [
      "articles-of-association.content.0",
      "articles-of-association.content.1",
      "articles-of-association.content.2"
    ],
    image: { 1: ExampleDeedOfArticlesOfAssociation }
  },
  [COMPANY_DOCUMENTS.DEED_OF_LATEST_BOARD]: {
    title: "deed-of-latest-board.title",
    text: ["deed-of-latest-board.content.0", "deed-of-latest-board.content.1", "deed-of-latest-board.content.2"],
    image: { 1: ExampleDeedOfLatestBoard }
  },
  [COMPANY_DOCUMENTS.NPWP]: {
    title: "npwp.title",
    text: ["npwp.content.0", "npwp.content.1"],
    image: { 1: ExampleOfNPWP }
  },
  [COMPANY_DOCUMENTS.NPWP_OWNER]: {
    title: "npwp-owner.title",
    text: ["npwp-owner.content.0", "npwp-owner.content.1"],
    image: { 1: ExampleOfNPWP }
  },
  [COMPANY_DOCUMENTS.SIUP]: {
    title: "siup.title",
    text: ["siup.content.0"] // default license
  },
  [COMPANY_DOCUMENTS.SIUP_FOUNDATION]: {
    title: "siup.title-foundation",
    text: ["siup.content.0"] // default license
  },
  [COMPANY_DOCUMENTS.INDUSTRY_LICENSE]: {
    title: "siup.title",
    text: ["siup.content.0"] // default license
  },
  [COMPANY_DOCUMENTS.NIB]: {
    title: "nib.title",
    text: ["nib.content.0", "nib.content.1", "nib.content.2"],
    image: { 1: ExampleOfNIB }
  },
  [COMPANY_DOCUMENTS.SK_KEMENKUMHAM]: {
    title: "sk-kemenkumham.title",
    text: ["sk-kemenkumham.content.0", "sk-kemenkumham.content.1", "sk-kemenkumham.content.2"]
  },
  [COMPANY_DOCUMENTS.SK_KEMENKUMHAM_AMENDMENT]: {
    title: "sk-kemenkumham-amendment.title",
    text: [
      "sk-kemenkumham-amendment.content.0",
      "sk-kemenkumham-amendment.content.1",
      "sk-kemenkumham-amendment.content.2"
    ]
  },
  [COMPANY_DOCUMENTS.ADDITIONAL_DOC]: {
    title: "siup.title",
    text: ["siup.content.0", "siup.content.1", "siup.content.2"] // default license
  },

  [COMPANY_DOCUMENTS.BUSINESS_CATALOG_ONLINE]: {
    title: "business-catalog-online.title",
    title_web: "business-catalog-online.title-web",
    text: ["business-catalog-online.content.0", "business-catalog-online.content.1"],
    text_web: ["business-catalog-online.content.2", "business-catalog-online.content.1"]
    // image: { 1:  ExampleOfBusinessCatalogue }
  },
  [COMPANY_DOCUMENTS.BUSINESS_CATALOG_OFFLINE]: {
    title: "business-catalog-offline.title",
    text: ["business-catalog-offline.content.0", "business-catalog-offline.content.1"],
    image: { 1: ExampleOfBusinessCatalogue }
  },
  [COMPANY_DOCUMENTS.TNC_CONTACT_POLICY_INFO]: {
    text: ["tnc-contact-policy-info"]
  },
  [COMPANY_DOCUMENTS.BUSINESS_ACTIVITIES_PHOTO_INDIVIDUAL_OFFLINE]: {
    title: "business-activities-photo-individual-offline.title",
    text: [
      "business-activities-photo-individual-offline.content.0",
      "business-activities-photo-individual-offline.content.1"
    ],
    image: { 1: ExampleOfBusinessActivityUMKMOffline }
  },
  [COMPANY_DOCUMENTS.BUSINESS_ACTIVITIES_PHOTO_INDIVIDUAL_ONLINE]: {
    title: "business-activities-photo-individual-online.title",
    text: [
      "business-activities-photo-individual-online.content.0",
      "business-activities-photo-individual-online.content.1",
      "business-activities-photo-individual-online.content.2"
    ],
    image: { 1: ExampleOfBusinessActivityUMKMOnline, 2: ExampleOfBusinessActivityUMKMOnline2 }
  },
  [COMPANY_DOCUMENTS.BUSINESS_ACTIVITIES_PHOTO_LEGAL_ENTITY]: {
    title: "business-activities-photo-legal-entity.title",
    text: [
      "business-activities-photo-legal-entity.content.0",
      "business-activities-photo-legal-entity.content.1",
      "business-activities-photo-legal-entity.content.2"
    ],
    image: { 1: ExampleOfBusinessActivityLegal, 2: ExampleOfBusinessActivityLegal2 }
  },
  ...GUIDANCE_UPLOAD_ENTITY_BASED_LICENSE,
  ...GUIDANCE_UPLOAD_INDUSTRY_BASED_LICENSE
};
